import { Spin, Flex } from "antd";

const PageSpinner = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        // Un mínimo, porque `height: 100%` sólo hace algo si el contenedor
        // tiene altura propia. Cuando no la tiene --y varias pantallas lo
        // devuelven directo, sin nada alrededor-- la caja colapsaba y el aviso
        // aparecía diminuto pegado al borde de arriba, en vez de centrado.
        minHeight: 240,
        width: "100%",
      }}
    >
      <Flex gap="middle" align="center" vertical>
        <Spin size="large" />
        <span>Cargando</span>
      </Flex>
    </div>
  );
};

export default PageSpinner;
